import React from "react";
import classNames from "classnames";
import { Badge, Icon, IconButton, RaiseColors, makeStyles } from "client/componentLibrary";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
var useStyles = makeStyles(function (theme) {
  return {
    icon: {
      fontWeight: 300,
      fontSize: "24px",
      "&:hover": {
        fontWeight: "normal"
      }
    },
    badge: {
      height: "16px",
      minWidth: "16px",
      maxWidth: "24px",
      fontSize: "12px",
      padding: "2px",
      paddingTop: "4px",
      borderRadius: function borderRadius(props) {
        return props.showRoundedCorners ? "4px" : undefined;
      },
      backgroundColor: RaiseColors.peach,
      color: RaiseColors.white
    },
    anchorOriginTopRightRectangular: {
      top: "2px",
      right: "1px"
    }
  };
});

/**
 * This button is used for unread comment status for listing engagement.
 * The count badge indicator will appear when there are new activities and hidden when the count is 0.
 */
var CommentActivityButton = function CommentActivityButton(_ref) {
  var count = _ref.count,
    toggleShowCommentFlyout = _ref.toggleShowCommentFlyout;
  var hasUnread = count !== undefined && count > 0;
  var showRoundedCorners = count !== undefined && count > 19;
  var classes = useStyles({
    showRoundedCorners: showRoundedCorners
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Badge, {
      badgeContent: count,
      invisible: !hasUnread,
      classes: {
        badge: classes.badge,
        anchorOriginTopRightRectangular: classes.anchorOriginTopRightRectangular
      },
      "data-testid": "badge-count",
      children: /*#__PURE__*/_jsx(IconButton, {
        disableRipple: true,
        onClick: toggleShowCommentFlyout,
        "data-testid": "client-notification-btn",
        children: /*#__PURE__*/_jsx(Icon, {
          "data-testid": "comment-icon",
          className: classNames(classes.icon, "fal fa-bell"),
          color: RaiseColors.glacier2400
        })
      })
    })
  });
};
export default CommentActivityButton;